import type { AppDefinition } from "@/client/core/Core.api";
import { isAppVisible } from "@/client/core/services/audience";
import { audienceStateSignal } from "@/client/core/services/feature-flags.signal";

/**
 * Deep-link guard: every app is a public static page, so hidden apps must
 * bounce non-entitled users back to the home directory once audiences
 * resolve. Embedded contexts are skipped — plugin and sidepanel hosts are
 * gates themselves, and older plugin hosts never deliver a token (the guard
 * would hard-lock them).
 */
export const initAppAccessGuard = (appDefinition: Readonly<AppDefinition>): void => {
    if (typeof window === "undefined" || window.parent !== window) {
        return;
    }
    audienceStateSignal.listenAndInit((state) => {
        if (state.isReady && !isAppVisible(appDefinition, state)) {
            window.location.replace("/");
        }
    });
};
